import type { ShareLink } from './types'

const storageKey = 'mapapal.sharedTrip'

export function parseShareLink(search: string): ShareLink | null {
  const params = new URLSearchParams(search)
  const tripId = params.get('id')?.trim() ?? ''
  const userNo = params.get('uno')?.trim() ?? ''

  if (!/^\d+$/.test(tripId) || userNo.length === 0) {
    return null
  }

  return { tripId, userNo }
}

export function stripShareParams(url: URL): string {
  const safeUrl = new URL(url)
  safeUrl.searchParams.delete('id')
  safeUrl.searchParams.delete('uno')
  const search = safeUrl.searchParams.toString()
  return `${safeUrl.pathname}${search ? `?${search}` : ''}${safeUrl.hash}`
}

export function storeShareLink(link: ShareLink): void {
  sessionStorage.setItem(storageKey, JSON.stringify(link))
}

export function readStoredShareLink(): ShareLink | null {
  try {
    const raw = sessionStorage.getItem(storageKey)
    if (!raw) return null
    const value = JSON.parse(raw) as Partial<ShareLink>
    if (!/^\d+$/.test(value.tripId ?? '') || !value.userNo) return null
    return { tripId: value.tripId!, userNo: value.userNo }
  } catch {
    return null
  }
}
